module.exports = "const { Generator, Filter } = Musika\n\nconst NoiseGen = () => {\n  const A = Math.SQRT1_2  // Amplitude = 0.707\n\n  const filter = Filter.Biquad()\n  return cutoff => {\n    const coeff = Filter.Biquad.LP(cutoff/sampleRate, Math.SQRT1_2)\n    return filter(coeff, Generator.random() * A)\n  }\n}\n\nconst noiseL = NoiseGen(), noiseR = NoiseGen()\nconst cutL = Generator.Sin(), cutR = Generator.Sin()\n\nreturn t => [\n  noiseL(300 + cutL(0.1, t) * 200),\n  noiseR(300 + cutR(0.08, t) * 200),\n]\n"


//////////////////
// WEBPACK FOOTER
// ../~/raw-loader!../examples/sea.js
// module id = 48
// module chunks = 1